import { render, staticRenderFns } from "./mouth.vue?vue&type=template&id=999abd2a&scoped=true&"
import script from "./mouth.vue?vue&type=script&lang=js&"
export * from "./mouth.vue?vue&type=script&lang=js&"
import style0 from "./mouth.vue?vue&type=style&index=0&id=999abd2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999abd2a",
  null
  
)

export default component.exports